<template>
    <div class="container" v-loading="tableing">
        <div class="header">试卷列表
            <el-button class="exit" size="mini" @click="logOut()"> 注销登录 </el-button>
        </div>
        <div class="main" ref="main">
            <div class="orgList" v-for="(item,index) in list" :key="index" @click="comeList(item)" :style="{background:((index+1)%3==1? 'rgb(0, 75, 180)':index%3==2?'rgb(156, 149, 219)':'rgb(96, 161, 261)')}">
                <div class="orgList-bg" 
                    :style="{backgroundPosition:((index+1)%3==1? '22% 35px,100% 0px':index%3==2?'55% 35px,100% 0px':'40% 35px,100% 0px')}"
                >
                    <div class="orgList-imgBox">
                        <img class="orgList-img" src="../../../static/images/type-img.png" alt="" srcset="">
                    </div>
                    <span class="orgList-name" :style="{lineHeight:(item.examMin>=0? '17px':''),marginTop:(item.examMin>=0? '14px':'')}">
                        {{item.name}}<br/><em class="timeLong">{{`考试时长：${item.examMin}分钟`}}</em>
                    </span>
                    <span class="orgList-text">去评测 <i class="el-icon-arrow-right"></i></span>
                </div>
            </div>
        </div>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page.pageNum"
            :page-sizes="arrPage"
            :page-size="page.pageSize"
            background
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            :hide-on-single-page="true"
            class="pagin"
            style="text-align: center;">
        </el-pagination>
    </div>
</template>
<script>
import AES from '../../lib/encryption';
import util from '../../lib/util';
    export default {
        name:"examList",
        data() {
            return {
                tableing:false,
                list:[],
                page:{
                    pageSize:10,
                    pageNum:1,  
                    total:null,
                },
                arrPage:[],
            }
        },
        components:{},
        watch: {},
        computed:{},
        created(){},
        mounted(){
            this.$nextTick(()=>{
                this.fooComput()
                if(this.$route.params.orgId){
                    sessionStorage.setItem("orgId",this.$route.params.orgId)
                }
            })
            window.addEventListener('resize', () => this.fooComput(), false)
        },
        methods:{
            fooComput(){
                this.page.pageSize = Math.floor(this.$refs.main.clientHeight/80)
                this.arrPage = [
                    this.page.pageSize*1,
                    this.page.pageSize*2,
                    this.page.pageSize*3,
                    this.page.pageSize*4,
                    this.page.pageSize*5,
                    this.page.pageSize*10,
                ]
                this.getData()
            },
            getData(){//测评
                let that = this
                let keys = 1234567890123456;
                let nOrgId = util.deepClone2(that.$route.params.orgId).replace(/@/g,"/")
                let encrypts = AES.decrypt(nOrgId,keys);
                that.tableing = true
                that.$axios.post('/paper/acg/paperAllList',{
                    pageNum:that.page.pageNum,
                    pageSize:that.page.pageSize,
                    orgId:encrypts,
                    uid:Number(that.$base64.decode(window.localStorage.getItem('uid-web'))),
                }, res => {
                    that.tableing = false;
                    let v = res.data;
                    if (v.code == 0) {
                        that.list = v.data.list
                        that.page.total = v.data.total;
                    }else{
                        if(v.msg)
                            that.$message.error(v.msg);
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            comeList(item){
                this.$nextTick(()=>{
                    this.$router.push({
                        path: '/mkfDetection',
                        query: {
                            bId:item.bId,
                            paperName:item.name,
                            userSignId:'',
                            ticketNum:'',
                            idName:'',
                            idCardNo:'',
                            personNum:'',
                        }
                    })
                })
            },
            handleSizeChange(val) {
                this.page.pageSize = val
                this.getData();
            },
            handleCurrentChange(val) {
                this.page.pageNum = val
                this.getData();
            },
            logOut(){
                localStorage.removeItem('poorVal')
                this.$router.push({
                    path: `/${this.$route.params.orgId}/login`,
                    query: {
                        phone:sessionStorage.getItem('phone')? sessionStorage.getItem('phone'):''
                    }
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .container{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .pagin{
        position: absolute;
        bottom: 10px;
        left: 0;
        right: 0;
    }
    .header{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 19px;
        font-weight: bold;
        color: #000;
        .exit{
            background-color: rgb(96,161,251);
            border: none;
            font-size: 13px;
            color: #fff;
            position: absolute;
            top: 20px;
            right: 10%;
            img{
                height: 10px;
            }
        }
    }
    .main{
        position: absolute;
        top: 60px;
        bottom: 45px;
        left: 0;
        right: 0;
        width: 100%;
    }
    .orgList{
        background-color: rgb(246, 246, 246);
        height: 60px;
        width: 80%;
        margin: 0 auto;
        display: block;
        margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04); 
        position: relative;
    }
    .orgList-bg{
        position: absolute;
        left: 0;
        top: 0;
        height: 100%;
        width: 100%;
        background-image: url('../../../static/images/bg_bottom.png'),url('../../../static/images/bg_top.png');
        background-repeat: no-repeat;
        background-size: 12% 100%,6% 50%;
        // background-position: 22% 35px,100% 0px;
    }     
    .orgList:hover {
        background-color: #f4f0f0;
    }
    .orgList:active {
        background-color: rgba(46, 103, 222, 0.13);
        height: 59.5px;
        width: 79.9%;
    }    
    .orgList-imgBox{
        width: 12%;
        height: 100%;
        float: left;
        text-align: right;
        box-sizing: border-box;
        padding-right: 8px;
        padding-top: 11px;
        padding-bottom: 9px;
    }
    .orgList-img{
        max-width: 100%;
        max-height:100%;
    }
    .orgList-name{
        box-sizing: border-box;
        padding-left: 8px;
        width: 70%;
        height: 60px;
        line-height: 60px;
        float: left;
        text-align: left;
        display: inline-block;
        font-family: STHeiti;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
    }
    .timeLong{
        font-size: 13px;
        font-family: STHeiti;
        font-style: unset;
    }
    .orgList-text{
        float: left;
        width: 10%;
        height: 30px;
        min-width: 96px;
        box-sizing: border-box;
        padding-left: 15px;
        // padding-right: 10px;
        margin-top: 15px;
        line-height: 30px;
        text-align: left;
        display: inline-block;
        font-family: STHeiti;
        font-size: 15px;
        color: #000;
        font-weight: bold;
        border-radius: 4px;
        background: #Fff;
        i{
            vertical-align: middle;
            margin-top:-3px;
        }
        i::before{
           margin-left: 1px;
           color: #000; 
           font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/examList/examList.vue